import moment from "moment-timezone";

import { getText } from "./language_helpers";

export const isValidPersonFormat = (inputString) => {
  // Test the inputString if in the format - Firstname Lastname (email)
  // Define the regex pattern
  const pattern = /^[A-Z][a-z]*(?: [A-Z][a-z]*)* [A-Z][a-z]*(?: [A-Z][a-z]*)* \([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\)$/;

  // Test the string against the pattern
  return pattern.test(inputString);
};

export const extractPersonDetails = (inputString) => {
  const regex = /^(.*?)\s+([\w\s]+)\s+\(([^)]+)\)$/;
  const match = inputString.match(regex);

  if (!match) return {};

  const firstName = match[1].trim();
  const lastName = match[2].trim();
  const email = match[3].trim();

  return {
    firstName,
    lastName,
    email,
  };
};

export const getValidAccountableManagers = (accountableManagers) => {
  return accountableManagers.filter((manenger) => isValidPersonFormat(manenger));
};

export const flattenAccountableManagers = (accountableManagers) => {
  let flattenedManagers = [];
  accountableManagers.forEach((manager) => {
    // accountable manager may be a comma separated list (from table input field)
    const users = manager
      .replaceAll("\n", "")
      .split(",")
      .map((user) => user.trim());
    flattenedManagers = flattenedManagers.concat(users);
  });
  return [...new Set(flattenedManagers)];
};

export const getTimeDuration = (dateInMoment) => {
  const today = moment();
  const numberOfDays = today.diff(dateInMoment, "days");
  if (numberOfDays) return `${numberOfDays} ${getText("day/s ago")}`;
  const numberOfHours = today.diff(dateInMoment, "hours");
  if (numberOfHours) return `${numberOfHours} ${getText("hr/s ago")}`;
  const numberOfMins = today.diff(dateInMoment, "minutes");
  if (numberOfMins) return `${numberOfMins} ${getText("min/s ago")}`;
};



// WEBPACK FOOTER //
// ./src/helpers/inspection_owner_helpers.js